import React, { useState, useEffect } from "react";
import calendarIcon from "../../assets/icons/calendar.svg";
import { useInput } from "../../hooks/use-input";
import Dropdown from "../../components/Form/Dropdown";
import CustomButton from "../../components/Buttons/CustomButton";

const planOptions = [
  { _id: "All", name: "All" },
  { _id: "Monthly", name: "Monthly" },
  { _id: "Annually", name: "Annually" },
];

const statusOptions = [
  { _id: "All", name: "All", displayName: "All" },
  { _id: "Active", name: "Active", displayName: "Active" },
  { _id: "Expired", name: "Expired", displayName: "Inactive" }, 
];

const SubscriptionFilter = ({ onApply, currentFilters = {} }) => {
  const [planType, setPlanType] = useState(currentFilters.planType || "All");
  const [status, setStatus] = useState(currentFilters.status || "All");
  const [startDate, setStartDate] = useState(currentFilters.startDate || "");
  const [endDate, setEndDate] = useState(currentFilters.endDate || "");

  
  useEffect(() => {
    console.log("Current filters changed:", currentFilters);
    setPlanType(currentFilters.planType || "All");
    setStatus(currentFilters.status || "All");
    setStartDate(currentFilters.startDate || "");
    setEndDate(currentFilters.endDate || "");
  }, [currentFilters]);


  const handleStatusSelect = (option) => {
    console.log("Status dropdown triggered with option:", option);
    
   
    let selectedValue;
    if (typeof option === 'string') {
      selectedValue = option;
    } else if (option && typeof option === 'object') {
      selectedValue = option.name || option.value || option._id || "All";
    } else {
      selectedValue = "All";
    }
    
    console.log("Setting status to:", selectedValue);
    setStatus(selectedValue);
  };

  const handlePlanTypeSelect = (option) => {
    console.log("Plan type dropdown triggered with option:", option);
    
    let selectedValue;
    if (typeof option === 'string') {
      selectedValue = option;
    } else if (option && typeof option === 'object') {
      selectedValue = option.name || option.value || option._id || "All";
    } else {
      selectedValue = "All";
    }
    
    console.log("Setting plan type to:", selectedValue);
    setPlanType(selectedValue);
  };

  const applyFilters = () => {
    const filterData = {
      startDate,
      endDate,
      status,
      planType,
    };
    
    console.log("Applying Filters:", filterData);
    
    // Call the parent callback
    if (onApply && typeof onApply === 'function') {
      onApply(filterData);
    } else {
      console.warn("onApply is not a function or is undefined");
    }
  };

  const clearFilters = () => {
    console.log("Clearing all filters");
    
    setPlanType("All");
    setStatus("All");
    setStartDate("");
    setEndDate("");
    
    const clearedFilters = { 
      startDate: "", 
      endDate: "", 
      status: "All", 
      planType: "All" 
    };
    
    console.log("Cleared filters:", clearedFilters);
    
    if (onApply && typeof onApply === 'function') {
      onApply(clearedFilters);
    }
  };

  // Show active filter count
  const activeFiltersCount = [
    planType !== "All" ? planType : null,
    status !== "All" ? status : null,
    startDate,
    endDate
  ].filter(Boolean).length;

  // Get selected option objects for dropdowns
  const selectedStatusOption = statusOptions.find(opt => opt.name === status);
  const selectedPlanOption = planOptions.find(opt => opt.name === planType);

  console.log("Current state:", { status, planType, selectedStatusOption, selectedPlanOption });

  return (
    <div className="w-full bg-[#111111d6] border border-[#505050] rounded-[8px] p-5 mb-6">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-[#E3E3E3] font-['Public Sans'] font-bold text-[20px] leading-[22px]">
          Filters
        </h2>
       
      </div>
      
      <div className="grid grid-cols-1 xl:grid-cols-[262px_1fr_1fr_auto] gap-4 items-end">
        {/* Date Range */}
        <div className="flex flex-col gap-2 w-[262px]">
          <label className="text-[#E3E3E3] text-[14px] leading-[22px] font-['Public Sans']">
            Date Range
          </label>
          <div className="flex items-center gap-[10px] bg-[#45444433] border border-[#808080] rounded-[5px] px-3 py-[10px]">
            {/* Start Date */}
            <div className="relative w-[110px]">
              <input
                type="date"
                name="startDate"
                value={startDate}
                placeholder="mm/dd/yyyy"
                onChange={(e) => setStartDate(e.target.value)}
                onFocus={(e) => {
                  if (!startDate) {
                    e.target.type = "date";
                  }
                }}
                className="custom-date w-full bg-transparent text-[14px] leading-[22px] font-['Public Sans'] text-[#B6B6B6CC] pr-6 outline-none placeholder-[#B6B6B6CC] cursor-pointer"
              />
              <img
                src={calendarIcon}
                alt="calendar"
                className="absolute right-[4px] top-1/2 transform -translate-y-1/2 w-[14px] h-[14px] pointer-events-none"
              />
            </div>

            {/* End Date */}
            <div className="relative w-[110px]">
              <input
                type="date"
                name="endDate"
                value={endDate}
                placeholder="mm/dd/yyyy"
                onChange={(e) => setEndDate(e.target.value)}
                onFocus={(e) => {
                  if (!endDate) {
                    e.target.type = "date";
                  }
                }}
                className="custom-date w-full bg-transparent text-[14px] leading-[22px] font-['Public Sans'] text-[#B6B6B6CC] pr-6 outline-none placeholder-[#B6B6B6CC] cursor-pointer"
              />
              <img
                src={calendarIcon}
                alt="calendar"
                className="absolute right-[4px] top-1/2 transform -translate-y-1/2 w-[14px] h-[14px] pointer-events-none"
              />
            </div>
          </div>
        </div>

        {/* Subscription Status */}
        <div>
          <Dropdown
            label="Subscription Status"
            options={statusOptions}
            placeholder="Select Status"
            displayKey="displayName"
            idKey="_id"
            wrapperClassName="text-[#E2E2E2] text-[15px] font-[300] font-['Public Sans'] w-full"
            dropdownClassName="bg-[#2D2D2D] border-[#808080] border z-20"
            optionClassName="text-[#E2E2E2] py-2 hover:bg-[#404040] cursor-pointer"
            buttonClassName="h-[45px] bg-[#45444433] border-[#808080] hover:border-[#51F9EF] transition-colors"
            filterClassName="border-t border-[#505050]"
            labelStyle="font-['Public_Sans'] font-normal text-[14px] leading-[22px] flex items-center text-[#E3E3E3] whitespace-nowrap mb-2"
            placeholderClassName="text-[#B6B6B6] text-[14px] font-['Public Sans'] font-normal"
            isSearchable={false}
            allowClear={false}
            // Try different prop names based on your Dropdown component API
            defaultOption={selectedStatusOption}
            selectedOption={selectedStatusOption}
            value={selectedStatusOption}
            defaultValue={status}
            onSelect={handleStatusSelect}
            onSelectOption={handleStatusSelect}
            onChange={handleStatusSelect}
          />
        </div>

        {/* Plan Type */}
        <div>
          <Dropdown
            label="Plan Type"
            options={planOptions}
            placeholder="Select Plan Type"
            wrapperClassName="text-[#E2E2E2] text-[15px] font-[300] font-['Public Sans'] w-full"
            dropdownClassName="bg-[#2D2D2D] border-[#808080] border z-20"
            optionClassName="text-[#E2E2E2] py-2 hover:bg-[#404040] cursor-pointer"
            buttonClassName="h-[45px] bg-[#45444433] border-[#808080] hover:border-[#51F9EF] transition-colors"
            filterClassName="border-t border-[#505050]"
            labelStyle="font-['Public_Sans'] font-normal text-[14px] leading-[22px] flex items-center text-[#E3E3E3] whitespace-nowrap mb-2"
            placeholderClassName="text-[#B6B6B6] text-[14px] font-['Public Sans'] font-normal"
            isSearchable={false}
            displayKey="name"
            defaultOption={selectedPlanOption}
            onSelect={handlePlanTypeSelect}
          />
        </div>

        {/* Buttons */}
        <div className="flex flex-row gap-3">
          <CustomButton
            useGradientBorder
            className="w-[123px] h-[42px] text-[18px] font-semibold font-['Public_Sans'] py-0 px-0"
            textColor="text-[#51F9EF]"
            gradient="bg-gradient-to-b from-[#51F9EF] to-[#1A7DD1]"
            onClick={applyFilters}
          >
            Apply Filters
          </CustomButton>
          <CustomButton
            className="w-[88px] h-[42px] text-[14px] font-normal font-inter py-0 px-0 uppercase hover:bg-[#9FB0AF20] transition-colors"
            textColor="text-[#9FB0AF]"
            borderColor="border-[#9FB0AF]"
            onClick={clearFilters}
          >
            Clear All
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionFilter;